module.exports = __webpack_public_path__ + "img/empty.165baf27.png";